/* ======== Globals ========= */

import { appLogo, mockedCompanyUrl } from "@constants/demo";
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import { isWeb } from "@helpers/platform";
import { useAppStore } from "@hooks/useAppStore";
import { useDevice } from "@hooks/useDevice";
import TooltipWrapper from "@memorang/ui/src/components/TooltipWrapper";
import { useRouter } from "expo-router";
/* ======== UI ========= */
import { Image, type ImageSourcePropType, Pressable, View } from "react-native";
import { Appbar, type AppbarProps, Text } from "react-native-paper";
type Props = {
	showLogo?: boolean;
	title?: string;
	onBackAction?: () => void;
	showProfileMenu?: boolean;
} & Omit<AppbarProps, "children">;
const OnboardingAppBar = ({
	showLogo,
	title,
	onBackAction,
	...rest
}: Props) => {
	const router = useRouter();

	const { isMobile } = useDevice();

	const _companyName = useAppStore((store) => store.companyName);
	// const appLogo = useAppStore((store) => store.app.logo);
	const companyUrl = mockedCompanyUrl;

	// const getAppLogo = () => {
	// 	const {
	// 		default: { light, dark },
	// 	} = appLogo;
	// 	return theme.dark ? dark : light;
	// };

	const navigateToPartnerSite = () => {
		window.open(companyUrl, "_blank");
	};
	const Logo = ({ image }: { image: ImageSourcePropType }) => {
		const logoImage = (
			<Image
				source={image}
				style={{
					width: 100,
					height: 38,
					marginLeft: -8,
					resizeMode: "contain",
				}}
				alt="Company Logo"
			/>
		);

		if (!router.canGoBack()) {
			return <View style={{ paddingLeft: 16 }}>{logoImage}</View>;
		}

		return (
			<Pressable
				style={{ paddingLeft: 16 }}
				onPress={() => router.back()}
				accessibilityRole="button"
				accessibilityLabel="Go back"
			>
				{logoImage}
			</Pressable>
		);
	};
	// If back action exists, showBackAction = true, otherwise false
	const showBackAction = !!onBackAction;

	const tooltipTitle = companyUrl
		?.replace("https://", "")
		.replace("www.", "")
		.replace("/", "");

	return (
		<Appbar.Header
			mode="center-aligned"
			{...rest}
			style={{
				position: "relative",
			}}
		>
			{showBackAction && (
				<Appbar.BackAction onPress={onBackAction} aria-hidden />
			)}
			{showLogo && (
				<Logo
					image={{
						uri: appLogo,
					}}
				/>
			)}
			<Appbar.Content title="" />

			<View
				style={{
					position: "absolute",
					width: "100%",
					height: "100%",
					justifyContent: "center",
					alignItems: "center",
					zIndex: -1,
				}}
			>
				<Text variant="titleLarge">{title}</Text>
			</View>
			{!isMobile && isWeb && (
				<TooltipWrapper title={`Go to ${tooltipTitle}`}>
					<Appbar.Action
						accessibilityRole="button"
						accessibilityLabel={`Go to ${tooltipTitle}`}
						onPress={navigateToPartnerSite}
						icon={(props) => (
							<MaterialCommunityIcons
								name="open-in-new"
								{...props}
								importantForAccessibility="no"
								aria-hidden={true}
							/>
						)}
					/>
				</TooltipWrapper>
			)}
		</Appbar.Header>
	);
};

export default OnboardingAppBar;
